import { getCountries } from 'react-phone-number-input/input';

const LANGUAGE_CODES = [
  'ar',
  'bn',
  'de',
  'en',
  'es',
  'fr',
  'gu',
  'hi',
  'id',
  'it',
  'ja',
  'ko',
  'mr',
  'nl',
  'pl',
  'pt',
  'ru',
  'ta',
  'te',
  'th',
  'tr',
  'uk',
  'ur',
  'vi',
  'zh',
];

function buildLabeledOptions(codes, type) {
  const names = new Intl.DisplayNames(['en'], { type });
  return codes
    .map((code) => {
      try {
        const name = names.of(code) || code;
        return type === 'language'
          ? { value: code, label: name }
          : { value: code, label: `${name} (${code})` };
      } catch {
        return { value: code, label: code };
      }
    })
    .sort((a, b) => a.label.localeCompare(b.label));
}

export const COUNTRY_OPTIONS = buildLabeledOptions(getCountries(), 'region');
export const LANGUAGE_OPTIONS = buildLabeledOptions(LANGUAGE_CODES, 'language');

export function withCurrentOption(options, value, fallbackLabel) {
  if (!value || options.some((opt) => String(opt.value) === String(value))) {
    return options;
  }
  const label =
    typeof fallbackLabel === 'function'
      ? fallbackLabel(value)
      : fallbackLabel || value;
  return [{ value, label }, ...options];
}

export function getOptionLabel(options, value, fallback = '—') {
  if (!value) return fallback;
  return (
    options.find((opt) => String(opt.value) === String(value))?.label || value
  );
}
